import CONST_COMPONENT from '../const/component'

import { KeywordComponent } from '../modules/default/KeywordComponent'
import { GetStartedComponent } from '../modules/default/GetStartedComponent'
import { MessengerEngagementPluginComponent } from '../modules/default/MessengerEngagementPluginComponent'

import {
  getConnectionTypeOncePicked,
  printMessageForDevelopmentMode,
  disableZoomForDoubleClick, 
  doNotShowContextMenu,
  doNotLetDeleteReferenceNode,
  warnForIncompatibleConnection,
  hideModalIfNodeRemoved,
  warnIfConnectionLimitCrosses,
  
  hideNewPostbackNodeAndModalElementsIfConnectedWithSequenceSingle,
  showNewPostbackNodeAndModalElementsIfConnectedWithSequenceSingle,

  showReferenceModalElementsIfActionButtonHasSpecificValue,
  hideReferenceModalElementsIfActionButtonHasSpecificValue,
  
  displayComponentListAndCreateNodeOnClick,

  toggleOutputConnectionOfNewQuestionOnCreated,
  toggleOutputConnectionOfNewQuestionOnRemoved,
  changeUniqueIdOnCloneNode,
  deleteChildrenNodesWhenDeletingParentNode,
} from '../listeners'

const sequence_addon = !! window.xitFlowBuilderData.sequence_addon
const messenger_bot_condition = !! window.xitFlowBuilderData.messenger_bot_condition
const user_input_flow_addon = !! window.xitFlowBuilderData.user_input_flow_addon
const instagram_bot_addon = !! window.xitFlowBuilderData.instagram_addon
const is_system_generated_action = !! window.xitFlowBuilderData.is_system_generated_action
const is_openai_addon_access = !!window.xitFlowBuilderData.is_openai_addon_access
const http_api_module = !! window.xitFlowBuilderData.http_api_module

const instagram_addon = window.xitFlowBuilderData.instagram_addon
var recurring_notification_addon = window.xitFlowBuilderData.recurring_notification_addon
var instagram_recurring_notification_addon = window.xitFlowBuilderData.instagram_recurring_notification_addon

var recurring_notification_display = 0;
if(!instagram_addon && recurring_notification_addon)
  recurring_notification_display = 1;
if(instagram_addon && instagram_recurring_notification_addon)
  recurring_notification_display = 1;


const hideFromContextMenu = [
  CONST_COMPONENT.POSTBACK,
  CONST_COMPONENT.COMPONENT_LIST,
  CONST_COMPONENT.BUTTON,
  CONST_COMPONENT.OTN,
  CONST_COMPONENT.OTN_SINGLE,
  CONST_COMPONENT.CAROUSEL_ITEM,
  CONST_COMPONENT.USER_INPUT_FLOW_SINGLE,
  CONST_COMPONENT.SEQUENCE_SINGLE,
  CONST_COMPONENT.ACTION_BUTTON,
]

if (!recurring_notification_display)
{
  hideFromContextMenu.push(CONST_COMPONENT.RECURRING_NOTIFICATION)
  hideFromContextMenu.push(CONST_COMPONENT.RCN_SINGLE)
}
  
const hideCloneMenuFromContextMenu = [
  CONST_COMPONENT.COMPONENT_LIST,
]

if (! sequence_addon) {
  hideFromContextMenu.push(CONST_COMPONENT.SEQUENCE)
  hideFromContextMenu.push(CONST_COMPONENT.SEQUENCE_SINGLE)
}

if (! is_openai_addon_access) {
  hideFromContextMenu.push(CONST_COMPONENT.OPEN_AI)
}

if(! http_api_module) {
  hideFromContextMenu.push(CONST_COMPONENT.HTTP_API)
}

if(! user_input_flow_addon) {
  hideFromContextMenu.push(CONST_COMPONENT.USER_INPUT_FLOW)
  hideFromContextMenu.push(CONST_COMPONENT.USER_INPUT_FLOW_SINGLE)
}

if(! messenger_bot_condition) {
  hideFromContextMenu.push(CONST_COMPONENT.CONDITION)
}

if (instagram_bot_addon) {
  hideFromContextMenu.push(CONST_COMPONENT.FACEBOOK_MEDIA)
  hideFromContextMenu.push(CONST_COMPONENT.AUDIO)
  hideFromContextMenu.push(CONST_COMPONENT.VIDEO)
  hideFromContextMenu.push(CONST_COMPONENT.FILE)
  hideFromContextMenu.push(CONST_COMPONENT.OTN)
  hideFromContextMenu.push(CONST_COMPONENT.OTN_SINGLE)
}

if (is_system_generated_action) {
  hideFromContextMenu.push(CONST_COMPONENT.ACTION_BUTTON)
}

const config = {
  moduleDir: 'modules',
  hideFromContextMenu: hideFromContextMenu,
  hideCloneMenuFromContextMenu: hideCloneMenuFromContextMenu,

  undroppableElements: [
    'xitFbGrip', 
    'fbDockmenu', 
    'hoverNodeCard'
  ],

  ignoreNodesWhileCheckingData: [
    CONST_COMPONENT.CONDITION,
  ],

  defaultComponentMappingTypeToClass: {
    'keyword': KeywordComponent,
    'get-started': GetStartedComponent,
    'messenger-engagement': MessengerEngagementPluginComponent,
  },

  eventsAndListeners: [
    { event: 'connectionpick', listener: getConnectionTypeOncePicked },
    { event: 'warn', listener: printMessageForDevelopmentMode },
    { event: 'zoom', listener: disableZoomForDoubleClick },
    { event: 'showcontextmenu', listener: doNotShowContextMenu },
    { event: 'noderemove', listener: doNotLetDeleteReferenceNode },
    { event: 'connectioncreate', listener: warnForIncompatibleConnection },
    { event: 'noderemoved', listener: hideModalIfNodeRemoved },

    { event: 'connectioncreated', listener: warnIfConnectionLimitCrosses },

    { event: 'connectioncreated', listener: hideNewPostbackNodeAndModalElementsIfConnectedWithSequenceSingle },
    { event: 'connectionremoved', listener: showNewPostbackNodeAndModalElementsIfConnectedWithSequenceSingle },

    { event: 'connectioncreated', listener: showReferenceModalElementsIfActionButtonHasSpecificValue },
    { event: 'connectionremoved', listener: hideReferenceModalElementsIfActionButtonHasSpecificValue },

    { event: 'connectioncreated', listener: toggleOutputConnectionOfNewQuestionOnCreated },
    { event: 'connectionremoved', listener: toggleOutputConnectionOfNewQuestionOnRemoved },
    
    { event: 'connectiondrop', listener: displayComponentListAndCreateNodeOnClick },
    
    { event: 'nodeclone', listener: changeUniqueIdOnCloneNode },

    { event: 'nodedelete', listener: deleteChildrenNodesWhenDeletingParentNode },
  ],
}

if (instagram_bot_addon) {
  config.ignoreNodesWhileCheckingData.push(CONST_COMPONENT.CAROUSEL)
}

export default config